export default "__VITE_ASSET__CYc1999k__"